module.exports = __webpack_public_path__ + "static/media/hero2.3aaebfd5.jpg";